module.exports = __webpack_public_path__ + "img/lingoLogoGreen2.b02370e8.png";